import { Close, ErrorOutline, Phone } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useLwp } from '../../hooks/use-lwp';
import { formatUSPhoneNumber } from '../../utils/formatter';
import { AlertError, CallBox, CallButton, CallDetails, CallHeader, CallStateError } from './call-styles';
import CallWarningActions from './call-warning-actions';

export interface CallErrorUnknownProps {
  message?: string;
}

export default function CallErrorUnknown(props: CallErrorUnknownProps) {
  const {
    hangupCall,
    phoneState: { phoneNumber, contactName, isErrorIgnored }
  } = useLwp();

  if (isErrorIgnored) return null;

  return (
    <CallBox data-testid="call-error-not-created">
      <CallHeader>
        <Grid container>
          <Grid item xs={6} zeroMinWidth>
            <CallStateError>ERROR</CallStateError>
            <Typography variant="h6" noWrap>
              {contactName ? contactName : ''}
            </Typography>
            <Typography variant="body2">{formatUSPhoneNumber(phoneNumber)}</Typography>
            <Typography variant="body2">--:--</Typography>
          </Grid>
          <Grid item xs={6} style={{ textAlign: 'right' }}>
            <CallButton
              disabled
              sx={{ backgroundColor: 'rgb(77, 206, 160)', '&:hover': { backgroundColor: 'rgb(77, 206, 160)' } }}
            >
              <Phone />
            </CallButton>
            <CallButton onClick={() => hangupCall()} palleteKey="secondary">
              <Close sx={{ fontSize: 32 }} />
            </CallButton>
          </Grid>
        </Grid>
        <AlertError icon={<ErrorOutline style={{ fontSize: 22, color: '#E31B0C' }} />} severity="error">
          {props.message ? props.message : 'There was an unknown error when setting up the web phone.'}
        </AlertError>
      </CallHeader>
      <CallDetails>
        <CallWarningActions phoneNumber={phoneNumber} />
      </CallDetails>
    </CallBox>
  );
}
